import React, { useEffect, useState } from 'react';
import { Box, Drawer, useMediaQuery, useTheme, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { refreshTokenNew, getCookie } from '../../utils/helper';
import Sidebar from './Silderbar/Sidebar'; // Đường dẫn đến file Sidebar bạn vừa tách
import Header from './Header/header';
import Footer from './Footer/footer';

const SIDEBAR_WIDTH = 280;

function DashboardLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [authDomain, setAuthDomain] = useState({});
  const hostname = window.location.hostname;

  useEffect(() => {
    refreshTokenNew();
    const token = getCookie('token');
    setAuthDomain(token);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: { md: 'flex' }, minHeight: '100vh', bgcolor: '#F8FAFC' }}>
      {/* 1. SIDEBAR: Chạy mượt trên cả Mobile và Desktop */}
      <Box component="nav" sx={{ width: { md: SIDEBAR_WIDTH }, flexShrink: { md: 0 } }}>
        <Drawer
          variant={isMobile ? 'temporary' : 'permanent'}
          open={isMobile ? mobileOpen : true}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }} // Tăng hiệu năng trên mobile
          sx={{
            '& .MuiDrawer-paper': {
              width: SIDEBAR_WIDTH,
              boxSizing: 'border-box',
              borderRight: '1px solid #E2E8F0',
              boxShadow: 'none',
            },
          }}
        >
          <Sidebar authDomain={authDomain} hostname={hostname} />
        </Drawer>
      </Box>

      {/* 2. MAIN CONTENT AREA */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { md: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          minHeight: '100vh',
        }}
      >
        {/* Header tích hợp nút đóng mở cho Mobile */}
        <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#FFF' }}>
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ ml: 2, mr: 1 }}
            >
              <MenuIcon />{' '}
              {/* <Typography variant="h4" sx={{ fontWeight: 800, color: '#1E293B', fontFamily: 'FS' }}>
                SIM PANEL
              </Typography> */}
            </IconButton>
          )}
          {/* <Box sx={{ flexGrow: 1 }}>
            <Header />
          </Box> */}
        </Box>

        {/* Nội dung trang web (Dashboard, Admin List, v.v.) */}
        <div>{children}</div>

        <Footer />
      </Box>
    </Box>
  );
}

export default DashboardLayout;
